import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { JiraProductDiscoveryPricingPageTemplate } from "@/templates/software/jira/product-discovery/jira-product-discovery-software-page/pricing/jira-product-discovery-pricing-page/src/jira-product-discovery-pricing-page.template";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";

import { AppPricingData } from "../../../../contentful";
import { UserLocale } from "../../../../utils/useGeoCurrency";

export type JiraProductDiscoveryPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const JiraProductDiscoveryPricingPage = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: JiraProductDiscoveryPricingPageProps) => {
    return (
        <PricingContentContextProviderRelay
            productId="jira-product-discovery"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="jpd-pricing-page">
                <JiraProductDiscoveryPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
